export default __webpack_public_path__ + "static/media/footer.7bffb40f.jpg";